'use strict'

angular
  .module('basalteApp')
  .constant('BAS_TIME', {
    EVT_TIME_UPDATED: 'evtBasTimeTimeUpdated'
  })
